const styles = theme => ({
    root: {
        display: 'flex'
    },
    formControl: {
        margin: theme.spacing(0)
    },
    group: {
        margin: `${theme.spacing(1)}px 0`
    },
    buttons: {
        marginTop: theme.spacing(1),
        marginBottom: 0,
        paddingBottom: '0!important'
    },
    button: {
        width: '100%',
        marginRight: theme.spacing(1.5),
        marginBottom: theme.spacing(1),
        color: '#fff'
    },
    questionPageFooterTextWrapper: {
        padding: theme.spacing(0, 0.25),
        '& p:last-child': {
            marginBottom: 0
        }
    },
    [theme.breakpoints.down(600)]: {
        buttons: {
            padding: '4px!important'
        },
        button: {
            padding: '4px 24px!important'
        }
    },
    rightIcon: {
        marginLeft: theme.spacing(1),
        marginTop: theme.spacing(0.75),
        marginBottom: theme.spacing(0.75),
        marginRight: -theme.spacing(1) * 0.5
    },
    radio: {
        minWidth: '110px'
    },
    selectButton: {
        marginTop: theme.spacing(1.7),
        marginRight: theme.spacing(2),
        minWidth: '112px'
    },
    logoImg: {
        filter: 'grayscale(100%)',
        opacity: 0.5
    },
    questionWrapper: {
        paddingBottom: theme.spacing(4),
        marginBottom: theme.spacing(-5) + 'px!important'
    },
    imageWrapper: {
        width: '100%',
        textAlign: 'center'
    },
    image: {
        maxWidth: '100%',
        height: 'auto'
    },
    dialog: {
        margin: '0 -24px!important'
    },
    questionContainer: {
        width: 'calc(100% + 16px)',
        margin: '-8px'
    },
    prelanderQuestion: {
        minHeight: 147
    },
    prelanderAnswerWrapper: {
        display: 'flex',
        justifyContent: 'center',
        margin: theme.spacing(0, -1),
        flexDirection: 'column',
        textAlign: 'center'
    },
    prelanderAnswer: {
        margin: theme.spacing(0.375, 0.5),
        padding: theme.spacing(0.25, 1),
        background: theme.palette.primary.main,
        color: '#fff',
        borderRadius: 32,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        [theme.breakpoints.up(600)]: {
            padding: theme.spacing(0.5, 1),
            margin: theme.spacing(0.5, 0.5),
            fontSize: '1rem'
        }
    },
    prelanderAnswerBottomWrapper: {
        marginTop: theme.spacing(2),
        [theme.breakpoints.up(600)]: {
            marginTop: theme.spacing(3)
        }
    },
    prelanderPercentageQuestion: {
        marginBottom: theme.spacing(1) + 'px!important',
        marginTop: theme.spacing(0.5),
        fontWeight: 600,
        fontSize: '1.1rem!important',
        textAlign: 'left!important',
        paddingLeft: theme.spacing(1) + 'px!important',
        [theme.breakpoints.up(600)]: {
            marginBottom: theme.spacing(1.5) + 'px!important'
        }
    },
    prelanderPercentageAnswersWrapper: {
        background: '#fff',
        boxShadow: theme.boxShadow ? theme.boxShadow : '0 3px 5px rgba(0,0,0,0.1)',
        borderRadius: theme.borderRadius ? theme.borderRadius + 'px!important' : '20px!important',
        padding: theme.spacing(0.125, 0)
    },
    prelanderPercentageAnswerWrapper: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: theme.spacing(0.25, 0.5, 0.25, 0.5),
        background: '#f7f7f7',
        overflow: 'hidden'
    },
    prelanderPercentageAnswerWrapperChecked: {},
    prelanderPercentageAnswerCheckedBackground: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        background: theme.palette.primary.main,
        opacity: 0.5
    },
    prelanderPercentageLabel: {
        zIndex: 1,
        lineHeight: 1,
        // background: '#969696',
        borderRadius: theme.borderRadius ? theme.borderRadius + 'px!important' : '20px!important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        margin: theme.spacing(0.5, 0.5),
        padding: theme.spacing(0.75, 0.75),
        fontWeight: 500,
        fontSize: '0.9rem',
        textAlign: 'left'
    },
    prelanderPercentageLabelChecked: {
        color: 'white',
        textShadow: '0px 0px 1px ' + theme.palette.primary.main + ', 0 1px 2px #000',
        fontSize: '0.94rem'
    },
    prelanderPercentageValue: {
        zIndex: 1,
        // background: '#f7f7f7',
        height: 16,
        minWidth: 34,
        padding: '1px 1px 0 1px',
        borderRadius: theme.borderRadius ? theme.borderRadius + 'px!important' : '20px!important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        margin: theme.spacing(0.5, 1),
        fontWeight: 600
    },
    prelanderPercentageValueChecked: {
        color: 'white',
        textShadow: '0px 0px 1px ' + theme.palette.primary.main + ', 0 1px 2px #000',
        fontWeight: 500
    },
    prelanderPercentageBar: {
        position: 'absolute',
        height: '100%',
        background: '#d4d4d4',
        borderBottomRightRadius: theme.borderRadius ? theme.borderRadius + 'px!important' : '20px!important',
        borderTopRightRadius: theme.borderRadius ? theme.borderRadius + 'px!important' : '20px!important',
        transition: 'width 1s ease-in-out'
    },
    prelanderPercentageBarChecked: {
        background: theme.palette.primary.main
    },
    nextButtonWrapper: {
        width: '100%',
        marginTop: theme.spacing(3),
        [theme.breakpoints.up(600)]: {
            marginTop: theme.spacing(4)
        },
        marginBottom: -32,
        paddingBottom: 32
    }
})

export { styles }
